module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/moneyViewLogo.55206e27.png";